import { sanitize } from '@/common/utils/helpers';
import {
  getGraphemeById,
  getMorphemesByIds,
  getSentenceById,
  getWordById,
  getWordGraphemes,
  getWordsByIds,
} from '@/common/utils/scopeAndSequence';

export function getCorrectSegmentsForSentenceBuilder(itemId: string) {
  const sentence = getSentenceById(itemId);
  if (!sentence) return;

  const words = getWordsByIds(sentence.words).map((w) => sanitize(w.spelling));
  return words.join(' ').split(' ');
}

export function getCorrectSegmentsForWordRifts(itemId: string) {
  const word = getWordById(itemId);
  if (!word) return;
  return [word.spelling];
}

export function getCorrectSegmentsForWordSums(itemId: string) {
  const word = getWordById(itemId);
  if (!word) return;
  return getMorphemesByIds(word.morphemes).map((m) => m.spelling);
}

export function getCorrectSegmentsForPhonemeForge(itemId: string) {
  const word = getWordById(itemId);
  if (!word) return;
  return getWordGraphemes(word).map((g) => g.spelling);
}

export function getCorrectSegmentsForMysticMatch(itemId: string) {
  const grapheme = getGraphemeById(itemId);
  if (!grapheme) return;
  return [grapheme.spelling];
}

export function getCorrectSegmentsForMorphMaster(itemId: string) {
  const word = getWordById(itemId);
  if (!word) return;
  return getMorphemesByIds(word.morphemes).map((g) => g.spelling);
}

export function getCorrectSegmentsForDefaultGame(itemId: string) {
  const word = getWordById(itemId);
  if (!word) return;
  return getWordGraphemes(word).map((g) => g.spelling);
}

export function getCorrectSegmentsForHeartWords(itemId: string) {
  const word = getWordById(itemId)?.spelling;
  if (!word) return;
  return [sanitize(word)];
}
